<template>
  <TooltipProvider>
    <ToastProvider>
      <slot />
    </ToastProvider>
  </TooltipProvider>
</template>

<script lang="ts" setup>
import { TooltipProvider } from "@/components/shadcn-ui";
</script>
